var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIconGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14 -195) translate(14 196)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M9 10h4c.552 0 1 .448 1 1v18H8V11c0-.552.448-1 1-1zM1 17h4c.552 0 1 .448 1 1v11H0V18c0-.552.448-1 1-1zM17 13h4c.552 0 1 .448 1 1v15h-6V14c0-.552.448-1 1-1zM25 6h4c.552 0 1 .448 1 1v22h-6V7c0-.552.448-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#757575",
    d: "M3 12.5L11 5.5 19 8.5 27 1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 12.5,
    r: 1.5,
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 5.5,
    r: 1.5,
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 8.5,
    r: 1.5,
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 1.5,
    r: 1.5,
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    fillRule: "nonzero",
    d: "M37 18.072L40.072 15 37 11.944 37.944 11 41.944 15 37.944 19z",
    transform: "translate(-14 -195) translate(14 196)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconGrey);
export default __webpack_public_path__ + "static/media/dashboard_icon_grey.e75fdc01326d3715f902244092a9ce6b.svg";
export { ForwardRef as ReactComponent };